<div class="sticky-progress-bar" *ngIf="progressPercentage > 0">
  <mat-progress-bar mode="determinate" [value]="progressPercentage"></mat-progress-bar>
</div>
<div class="container-body">
  <mat-card class="survey-card">
    <mat-toolbar color="primary" class="rounded-toolbar" *ngIf="!previewId">
      <mat-toolbar-row>
        <button mat-icon-button (click)="validateBackNavigation()">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <span class="spacer"></span>
        <span>Progress: {{ progressPercentage }}%</span>
      </mat-toolbar-row>
    </mat-toolbar>
    <mat-card-header>
      <mat-card-title class="survey-title">
        <div class="event-name text-lg uppercase tracking-wide text-gray-600" *ngIf="surveyData.eventName">
          {{ surveyData.eventName }}
        </div>
        <div class="text-3xl font-semibold text-gray-800 text-center">
          {{ surveyData.title }}
        </div>
      </mat-card-title>
      <mat-card-subtitle>
        <span class="description text-base text-gray-600 leading-relaxed block text-center">
          {{ surveyData.description }}
        </span>
        <div *ngIf="surveyData.instructions"
          class="instructions-container mt-6 mb-8 p-4 bg-gray-50 rounded border-l-4 border-blue-500">
          <div class="instructions-header mb-3">
            <h4 class="text-sm font-semibold text-gray-800 uppercase tracking-wider margin-0">Instructions</h4>
          </div>
          <div class="instructions-content text-sm text-gray-700 leading-relaxed" [innerHTML]="surveyData.instructions">
          </div>
        </div>
      </mat-card-subtitle>

    </mat-card-header>

    <mat-card-content>
      <div class="image-container" *ngIf="assets">

        <img *ngIf="surveyData.image" [src]="getAssets()" class="image-preview">

      </div>
      <form>

        @if (surveyData.useSections && surveyData.sections && surveyData.sections.length > 0) {
          @for (section of surveyData.sections; let sectionIndex = $index; track section.sectionId) {
            <div class="section-container mb-6" [class.border]="!section.hideHeader" [class.border-gray-200]="!section.hideHeader" [class.rounded-lg]="!section.hideHeader" [class.overflow-hidden]="!section.hideHeader" [class.shadow-sm]="!section.hideHeader">
              @if (!section.hideHeader) {
                <div class="section-header bg-gradient-to-r from-blue-50 to-blue-100 px-4 py-3 border-b border-gray-200">
                  <h3 class="text-lg font-semibold text-gray-800 m-0">{{ section.title }}</h3>
                  <p class="text-xs text-gray-600 mt-1 mb-0">{{ getQuestionsForSection(section).length }} {{ getQuestionsForSection(section).length === 1 ? 'question' : 'questions' }}</p>
                  <div *ngIf="section.instructions" class="mt-3 pt-2 border-t border-blue-200">
                    <div class="text-sm text-gray-700 leading-relaxed" [innerHTML]="section.instructions"></div>
                  </div>
                </div>
              }
              <div [class.section-questions]="!section.hideHeader" [class.bg-white]="!section.hideHeader" [class.p-4]="!section.hideHeader">
                @for (question of getQuestionsForSection(section); let i = $index; track question.questionId) {
                  <div class="question-margin">
                    <app-survey-qtype-preview [question]="question" [questionNumber]="question.order"
                      (valueChanged)="onQuestionValueChanged($event)" [savedValue]="getSavedValue(question)"
                      [savedFolloupValue]="getFollowUpSavedValue(question)" [assets]="assets"></app-survey-qtype-preview>
                  </div>
                }
              </div>
            </div>
          }
        } @else {
          <!-- Backward compatibility: render as if it were a section with hideHeader: true -->
          @for (item of surveyData.questions; let i = $index; track item.questionId) {
            <div class="question-margin">
              <app-survey-qtype-preview [question]="item" [questionNumber]="i + 1"
                (valueChanged)="onQuestionValueChanged($event)" [savedValue]="getSavedValue(item)"
                [savedFolloupValue]="getFollowUpSavedValue(item)" [assets]="assets"></app-survey-qtype-preview>
                
            </div>
          }
        }
      </form>
      <hr class="separator" *ngIf="!previewId" />
      <div class="submit-button-container" *ngIf="!previewId">
        <button mat-raised-button class="btn-primary custom-button" [disabled]="errors.length || isLoading"
          (click)="submit()">
          <span class="button-content">
            <mat-spinner *ngIf="isLoading" class="custom-spinner" diameter="20"></mat-spinner>
            <mat-icon *ngIf="!isLoading">check</mat-icon>
            Complete Survey
          </span>
        </button>
        <app-error-badge [errors]="errors" [errorLabel]="'requirements'" [openFrom]="'top'"></app-error-badge>
      </div>
    </mat-card-content>
  </mat-card>
</div>
